<table>
  <tr *ngFor="let row of desChoices; let i = index">
    <td [hidden]="!allowAddMoreRows">
      <a [hidden]="i === 0" href="javascript:void(0);" (click)="deleteChoice(i)" style="position: relative; top:12px; font-size:x-large"><i class="ti-trash"></i></a>
    </td>
    <td style="width: 18%;  text-align:center" [hidden]="reportsPage">
      {{i == 0 ? 'Amount ($)' + asterisk : '&nbsp;'}}
      <input type="text" id="{{'amount' + i}}" [(ngModel)]="row.choiceAmount" maxlength="11" class="currency-input form-control" trimOnBlur data-not-blank mask="separator.2" thousandSeparator="," [dropSpecialCharacters]="true" (blur)="onBlurDesAmount(i)">
    </td>
    <td style="min-width: 110px; text-align:center; white-space: nowrap" [style.padding-left]="reportsPage ? '0' : '5px'">
      {{i == 0 ? 'Designation' + asterisk : '&nbsp;'}}
      <select class="form-control" [(ngModel)]="row.desNo" (change)='onDesignationSelected(i)' id="{{'desDropdown' + i}}" data-not-blank>
        <option value="-1" [hidden]="!reportsPage || advancedFilter">All</option>
        <option *ngFor='let option of desOptions' [value]="option.desNo">
          {{option.desName}}
        </option>
      </select>
    </td>
    <td style="min-width: 110px; text-align:center; white-space: nowrap" [style.padding-left]="reportsPage && !advancedFilter ? '15px' : '5px'">
      {{row.desSelected && row.desSelected.subName1 ? row.desSelected.subName1 + asterisk : ''}}
      <select class="form-control" [(ngModel)]="row.subItemNo1" (change)='onSubItem1Selected(i)' id="{{'subDes1Dropdown' + i}}" [hidden]="row.desSelected ? !row.desSelected.subName1 : true" data-not-blank>
        <option value="null" [hidden]="!reportsPage"></option>
        <option *ngFor='let option of row.subItems1' [value]="option.subItemNo">
          {{option.itemValue}}
        </option>
      </select>
    </td>
    <td style="min-width: 110px; text-align:center; white-space: nowrap" [style.padding-left]="reportsPage && !advancedFilter ? '15px' : '5px'">
      {{row.desSelected && row.desSelected.subName2 ? row.desSelected.subName2 + asterisk : ''}}
      <select class="form-control" [(ngModel)]="row.subItemNo2" (change)='onSubItem2Selected(i)' id="{{'subDes2Dropdown' + i}}" [hidden]="row.desSelected ? !row.desSelected.subName2 : true" data-not-blank>
        <option value="null" [hidden]="!reportsPage"></option>
        <option *ngFor='let option of row.subItems2' [value]="option.subItemNo">
          {{option.itemValue}}
        </option>
      </select>
    </td>
    <td style="min-width: 110px; text-align:center; white-space: nowrap" [style.padding-left]="reportsPage && !advancedFilter ? '0px' : '5px'">
      {{row.desSelected && row.desSelected.subName3 ? row.desSelected.subName3 + asterisk : ''}}
      <select class="form-control" [(ngModel)]="row.subItemNo3" (change)='checkForAllowPledge(i)' id="{{'subDes3Dropdown' + i}}" [hidden]="row.desSelected ? !row.desSelected.subName3 : true" data-not-blank>
        <option value="null" [hidden]="!reportsPage"></option>
        <option *ngFor='let option of row.subItems3' [value]="option.subItemNo">
          {{option.itemValue}}
        </option>
      </select>
    </td>
    <td style="text-align:center;" [hidden]="!contributionsPage">
      {{i == 0 ? 'Fulfills pledge' : '&nbsp;'}}<br />
      <input type="checkbox" [(ngModel)]="row.fulfillsPledge" class="big-checkbox" style="margin-top: 14px;" [style.visibility]="row.allowPledge ? 'visible' : 'hidden'">
    </td>
  </tr>
</table>
<div [hidden]="!allowAddMoreRows" style="padding-top: 5px; width:100%">
  <button (click)="addDesChoice()">Add designation</button>
  <span style="float: right; margin-top: 10px" [ngClass]="differenceBetweenCorrectSumAndTotalDes != '0.00' ? 'red-text' : ''">
    Remaining contribution to allocate: <b>{{differenceBetweenCorrectSumAndTotalDes}}</b>
  </span>
</div>
